import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import headlogo from "../../img/logo/header-logo4.png";
import service8 from "../../img/demo/demo1.png";
import service9 from "../../img/demo/demo2.png";
import service99 from "../../img/demo/demo3.png";
import sere from "../../img/demo/demo4.png";
import loginIcon from "../../img/icons/login.png";
import bank1 from "../../img/icons/bank1.svg";
import bank2 from "../../img/icons/bank2.svg";
import bank3 from "../../img/icons/bank3.svg";
import shapesMain from "../../img/shapes/hero4-main-shape.png";
import heroMain from "../../img/hero/hero4-main-image.png";
import shape1 from "../../img/shapes/hero4-shape1.png";
import shape2 from "../../img/shapes/hero4-shape2.png";
import shape3 from "../../img/shapes/hero4-shape3.png";
import secHero from "../../img/shapes/hero4-sec-shape.png";
import choosebg from "../../img/shapes/choose4-bg.png";
import chooseMain from "../../img/others/choose4-main-img.png";
import chosseShape from "../../img/shapes/chosse4-shape.png";
import icon1 from "../../img/icons/choose4-icon1.png";
import icon2 from "../../img/icons/choose4-icon2.png";
import icon3 from "../../img/icons/choose4-icon3.png";
import marketing1 from "../../img/logo/marketing-logo1.png";
import marketing2 from "../../img/logo/marketing-logo2.png";
import marketing3 from "../../img/logo/marketing-logo3.png";
import marketing4 from "../../img/logo/marketing-logo4.png";
import marketing5 from "../../img/logo/marketing-logo5.png";
import marketing6 from "../../img/logo/marketing-logo6.png";
import chart1 from "../../img/shapes/chart4-shape1.png";
import chart2 from "../../img/shapes/chart4-shape2.png";
import sellOthers from "../../img/others/sell-betcoin-main-img.png";
import sell1 from "../../img/shapes/sell-betcoin-img-shape1.png";
import sell2 from "../../img/shapes/sell-betcoin-img-shape2.png";
import work1 from "../../img/work/work4-img1.png";
import work2 from "../../img/work/work4-img2.png";
import work3 from "../../img/work/work4-img3.png";
import appleBtn from "../../img/others/apple-btn.png";
import gooleBtn from "../../img/others/goole-btn.png";
import areaImg from "../../img/others/mobile-area4-main-image.png";
import areaBetcoin from "../../img/shapes/mobile-area4-betcoin.png";
import areaQr from "../../img/shapes/mobile-area4-qr.png";
import areaArrow from "../../img/shapes/mobile-area4-arrow.png";
import areabg from "../../img/shapes/mobile-area4-shape-bg.png";
import testimonialSmall from "../../img/testimonial/testimonial4-smoll-img.png";
import testimonialMain from "../../img/testimonial/testimonial4-main-img.png";
import qute from "../../img/icons/qute4.png";
import test1 from "../../img/shapes/tes4-shape1.png";
import test2 from "../../img/shapes/tes4-shape2.png";
import blogImg1 from "../../img/blog/blog1-image1.png";
import blogImg2 from "../../img/blog/blog1-image2.png";
import blogImg3 from "../../img/blog/blog1-image3.png";
import author from "../../img/icons/author.png";
import date from "../../img/icons/date.png";
import footerlogo from '../../img/logo/header-logo4.png';
import footerimg1 from '../../img/shapes/footer-shape2.png';
import footerimg2 from '../../img/shapes/footer-shape3.png';
import footerimg3 from '../../img/shapes/footer-shape4.png';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperCore from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { faFacebookF, faGooglePlusG, faInstagram, faLinkedinIn, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';

SwiperCore.use([Navigation, Autoplay]);

const SingleIndexHomepages = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,  // You can set the duration here or directly in the HTML as data-aos-duration
        });
    }, []);

    const navigate = useNavigate();

    return (
        <>
            <div>
                <div class="header-area header-area4 single-header4 header-area-all d-none d-lg-block" id="header">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="header-elements">
                                    <div class="site-logo">
                                        <a href="/">
                                            <img src={headlogo} alt="" />
                                        </a>
                                    </div>


                                    <div class="main-menu-ex main-menu-ex1">
                                        <ul id="list-example">
                                            <li><a href="#">Home <i class="fa-solid fa-angle-down"></i></a>
                                                <div class="tp-submenu">
                                                    <div class="row">
                                                        <div class="col-lg-12">
                                                            <div class="all-images-menu">
                                                                <div class="homemenu-thumb">
                                                                    <div class="img1">
                                                                        <img src={service8} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        <a class="header-btn1" href="/">Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="single-/" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate('/singlePage')} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>

                                                                <div class="homemenu-thumb">
                                                                    <div class="img1">
                                                                        <img src={service9} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        {/* <a class="header-btn1" href="/home2MultiPagel">Multi Page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeMultipage")} >Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="/home2MultiPage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeSinglePage")}>One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>


                                                                <div class="homemenu-thumb">
                                                                    <div class="img1">
                                                                        <img src={service99} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        <a class="header-btn1" href="/home2MultiPage">Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="/home2SinglePage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/home2SinglePage")} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>

                                                                <div class="homemenu-thumb" style={{ margin: "0" }}>
                                                                    <div class="img1">
                                                                        <img src={sere} alt="" />
                                                                    </div>
                                                                    <div class="homemenu-btn">
                                                                        {/* <a class="header-btn1" href="/homeIndexMultiPage">Multi Page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeIndexMultiPage")} >Multi Page <i class="fa-solid fa-arrow-right"></i></a>
                                                                        <div class="space16"></div>
                                                                        {/* <a class="header-btn1" href="single-/homeIndexMultiPage" target="_blank">One page <i class="fa-solid fa-arrow-right"></i></a> */}
                                                                        <a class="header-btn1" onClick={() => navigate("/homeIndexSinglePage")} >One page <i class="fa-solid fa-arrow-right"></i></a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li><a class="list-group-item list-group-item-action" href="#choose">Choose</a></li>
                                            <li><a class="list-group-item list-group-item-action" href="#market">Market</a></li>
                                            <li><a class="list-group-item list-group-item-action" href="#work">Work</a></li>
                                            <li><a class="list-group-item list-group-item-action" href="#tes">Testimonial</a></li>
                                            <li><a class="list-group-item list-group-item-action" href="#blog">Blog</a></li>
                                        </ul>
                                    </div>

                                    <div class="header2-buttons">
                                        <div class="button">
                                            <a href="#" class="login">Login <img src={loginIcon} alt="" /></a>
                                            <a class="theme-btn4" href="/contact">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mobile-header mobile-header-main d-block d-lg-none ">
                    <div class="container-fluid">
                        <div class="col-12">
                            <div class="mobile-header-elements">
                                <div class="mobile-logo">
                                    <a href="/"><img src={headlogo} alt="" /></a>
                                </div>
                                <div class="mobile-nav-icon">
                                    <i class="fa-duotone fa-bars-staggered"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mobile-sidebar d-block d-lg-none">
                    <div class="logo-m">
                        <a href="/"><img src={headlogo} alt="" /></a>
                    </div>
                    <div class="menu-close">
                        <i class="fa-solid fa-xmark"></i>
                    </div>
                    <div class="mobile-nav">

                        <ul>
                            <li class="has-dropdown"><a href="#">Home </a>
                                <ul class="sub-menu">
                                    <li class="has-dropdown has-dropdown1"><a href="#">Multipage</a>
                                        <ul class="sub-menu">
                                            <li><a href="/">Home 1</a></li>
                                            <li><a href="/home2MultiPagel">Home 2</a></li>
                                            <li><a href="/home2MultiPage">Home 3</a></li>
                                            <li><a href="/homeIndexMultiPage">Home 4</a></li>
                                        </ul>
                                    </li>
                                    <li class="has-dropdown has-dropdown1"><a href="#">Landing Page</a>
                                        <ul class="sub-menu">
                                            <li><a href="single-/">Home 1</a></li>
                                            <li><a href="/home2MultiPage">Home 2</a></li>
                                            <li><a href="/home2SinglePage">Home 3</a></li>
                                            <li><a href="single-/homeIndexMultiPage">Home 4 </a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li><a href="/about">About Us</a></li>
                            <li class="has-dropdown"><a href="#">Market</a>
                                <ul class="sub-menu">
                                    <li><a href="/buyCrypto">Buy Crypto</a></li>
                                    <li><a href="/sellBuyCrypto">Sell Crypto</a></li>
                                </ul>
                            </li>

                            <li class="has-dropdown"><a href="#">Pages</a>
                                <ul class="sub-menu">
                                    <li><a href="/contact">Contact</a></li>
                                    <li><a href="/faq">FAQ</a></li>
                                    <li><a href="/error">404</a></li>
                                </ul>
                            </li>

                            <li><a href="/blog">Blog</a></li>
                            <li class="has-dropdown has-dropdown1"><a href="/blogDetail" class="main">Blog Detials</a>
                                <ul class="sub-menu">
                                    <li><a href="/blogDetailLeft">Details Left</a></li>
                                    <li><a href="/blogDetailRight">Details Right</a></li>
                                    <li><a href="/blogDetail">Single Details</a></li>
                                </ul>
                            </li>

                            <li class="has-dropdown"><a href="#">Account</a>
                                <ul class="sub-menu">
                                    <li><a href="/user">My Profile</a></li>
                                    <li><a href="/login">Login</a></li>
                                    <li><a href="/register">Register</a></li>
                                </ul>
                            </li>

                        </ul>

                        <div class="mobile-button">
                            <a class="theme-btn4" href="/contact">Contact Us <span><i class="fa-solid fa-arrow-right"></i></span></a>
                        </div>

                        <div class="single-footer-items">
                            <h3>Contact Us</h3>

                            <div class="contact-box">
                                <div class="pera">
                                    <a href="tel:+880123456789">+880 123 456 789</a>
                                </div>
                            </div>

                            <div class="contact-box">
                                <div class="pera">
                                    <a href="mailto:info@mail.com">info@mail.com</a>
                                </div>
                            </div>

                            <div class="contact-box">
                                <div class="pera">
                                    <a href="tel:+880123456789">8502 Preston Rd. <br /> Inglewoo Maine 98380</a>
                                </div>
                            </div>

                        </div>

                        <div class="contact-infos">
                            <h3>Our Location</h3>
                            <ul class="social-icon">
                                <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                <li><a href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
                                <li><a href="#"><i class="fa-brands fa-youtube"></i></a></li>
                                <li><a href="#"><i class="fa-brands fa-instagram"></i></a></li>
                            </ul>
                        </div>

                    </div>
                </div>

                <div class="hero-area4">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-5">
                                <div class="main-heading">
                                    <span class="span" data-aos="zoom-in-left" data-aos-duration="700">Invest in the Future of PayCoin</span>
                                    <h1 class="text-anime-style-3">Welcome To The Next Generation A Cryptocurrency</h1>
                                    <div class="space16"></div>
                                    <p data-aos="zoom-in-left" data-aos-duration="900">At PayCoin, we're committed to providing you with at a cutting-edge trading experience a  that goes beyond.</p>
                                    <div class="subscribe-form" data-aos="zoom-in-left" data-aos-duration="1100">
                                        <form action="#">
                                            <input type="email" placeholder="Email Address" />
                                            <div class="button">
                                                <button class="theme-btn4">Get A Quote <span><i class="fa-solid fa-arrow-right"></i></span></button>
                                            </div>
                                        </form>
                                        <div class="pay-option">
                                            <ul>
                                                <li class="text">Buy Crypto With:</li>
                                                <li><a href="#"><img src={bank1} alt="" /></a></li>
                                                <li><a href="#"><img src={bank2} alt="" /></a></li>
                                                <li><a href="#"><img src={bank3} alt="" /></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-7">
                                <div class="all-images">
                                    <div class="main-image-bg">
                                        <img src={shapesMain} alt="" />
                                    </div>
                                    <div class="main-image reveal">
                                        <img src={heroMain} alt="" />
                                    </div>
                                    <div class="hero4-shape1 animate2 reveal">
                                        <img src={shape1} alt="" />
                                    </div>
                                    <div class="hero4-shape2 animate3">
                                        <img src={shape2} alt="" />
                                    </div>
                                    <div class="hero4-shape3 animate1">
                                        <img src={shape3} alt="" />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                    <img src={secHero} alt="" class="sec-shape" />
                </div>

                <div data-bs-spy="scroll" data-bs-target="#list-example" data-bs-offset="0" class="scrollspy-example" tabindex="0">


                    <div class="chosse4 sp" id="choose">
                        <div class="container">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="chosse4-all-images" data-aos="zoom-out" data-aos-duration="900">
                                        <div class="image1">
                                            <img src={choosebg} alt="" />
                                        </div>
                                        <div class="image2">
                                            <img src={chooseMain} alt="" />
                                        </div>
                                        <div class="image3 animate2">
                                            <img src={chosseShape} alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">WHY COOOSE PAYCOIN</span>
                                        <h2 class="text-anime-style-3">Where Innovation Meets Cryptocurrency Trading</h2>
                                        <div class="space16"></div>
                                        <p data-aos="fade-left" data-aos-duration="800">At PayCoin, we pride ourselves on offering a user-friendly platform that caters to both novice traders & seasoned PayCoin investors.</p>

                                        <div class="counter-area" data-aos="fade-left" data-aos-duration="1000">
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="counter-single after">
                                                        <p><img src={icon1} alt="" /> Bitcoin Sell</p>
                                                        <h3><span class="counter">10</span>B+</h3>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="counter-single after">
                                                        <p><img src={icon2} alt="" /> Digital Assets</p>
                                                        <h3><span class="counter">100</span>M+</h3>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="counter-single">
                                                        <p><img src={icon3} alt="" /> Happy User</p>
                                                        <h3><span class="counter">980</span>M+</h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="space40"></div>
                                        <div class="" data-aos="fade-left" data-aos-duration="1100">
                                            <a class="theme-btn4" href="/contact">Get Started <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <section class="coin-list coin-list4 sp" id="market">
                        <div class="container">

                            <div class="row">
                                <div class="col-lg-8 m-auto text-center">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">BItCoin Market update</span>
                                        <h2 class="text-anime-style-3">Cryptocurrency Market Update</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="space20"></div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="coin-list__main">
                                        <div class="flat-tabs" data-aos="fade-up" data-aos-duration="800">
                                            <div class="content-tab">
                                                <div class="content-inner">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col"></th>
                                                                <th scope="col">Name/Pair</th>
                                                                <th scope="col">Last Price</th>
                                                                <th scope="col">24 Change</th>
                                                                <th scope="col">Chart</th>
                                                                <th scope="col">Trade</th>
                                                                <th scope="col"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="spacer">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row"><span class="icon-star"><i class="fa-regular fa-star"></i></span></th>
                                                                <td class='align-middle'>
                                                                    <a href="#">
                                                                        <img src={marketing1} alt="" />
                                                                        <span>BitCoin (BSTD)</span>
                                                                    </a>
                                                                </td>
                                                                <td class="boild align-middle">$56,623.54</td>
                                                                <td class="up align-middle">+1.45%</td>
                                                                <td class='align-middle'><div id="total-revenue-chart-1"></div></td>
                                                                <td class='align-middle'><a href="#" class="btn">Trade</a></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr class="spacer">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row"><span class="icon-star"><i class="fa-regular fa-star"></i></span></th>
                                                                <td class='align-middle'>
                                                                    <a href="#">
                                                                        <img src={marketing2} alt="" />
                                                                        <span>Ethereum (ETH)</span>
                                                                    </a>
                                                                </td>
                                                                <td class="boild align-middle">$56,623.54</td>
                                                                <td class="up align-middle">-5.12%</td>
                                                                <td class='align-middle'><div id="total-revenue-chart-2"></div></td>
                                                                <td class='align-middle'><a href="#" class="btn">Trade</a></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr class="spacer">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row"><span class="icon-star"><i class="fa-regular fa-star"></i></span></th>
                                                                <td class='align-middle'>
                                                                    <a href="#">
                                                                        <img src={marketing3} alt="" />
                                                                        <span>Binance (BNB)</span>
                                                                    </a>
                                                                </td>
                                                                <td class="boild align-middle">$56,623.54</td>
                                                                <td class="up align-middle">-3.75%</td>
                                                                <td class='align-middle'><div id="total-revenue-chart-3"></div></td>
                                                                <td class='align-middle'><a href="#" class="btn">Trade</a></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr class="spacer">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row"><span class="icon-star"><i class="fa-regular fa-star"></i></span></th>
                                                                <td class='align-middle'>
                                                                    <a href="#">
                                                                        <img src={marketing4} alt="" />
                                                                        <span>Tether (USDT)</span>
                                                                    </a>
                                                                </td>
                                                                <td class="boild align-middle">$56,623.54</td>
                                                                <td class="up align-middle">+1.45%</td>
                                                                <td class='align-middle'><div id="total-revenue-chart-4"></div></td>
                                                                <td class='align-middle'><a href="#" class="btn">Trade</a></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr class="spacer">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row"><span class="icon-star"><i class="fa-regular fa-star"></i></span></th>
                                                                <td class='align-middle'>
                                                                    <a href="#">
                                                                        <img src={marketing5} alt="" />
                                                                        <span>Solana (SOL)</span>
                                                                    </a>
                                                                </td>
                                                                <td class="boild align-middle">$56,623.54</td>
                                                                <td class="down align-middle">+1.45%</td>
                                                                <td class='align-middle'><div id="total-revenue-chart-5"></div></td>
                                                                <td class='align-middle'><a href="#" class="btn">Trade</a></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr class="spacer">
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row"><span class="icon-star"><i class="fa-regular fa-star"></i></span></th>
                                                                <td class='align-middle'>
                                                                    <a href="#">
                                                                        <img src={marketing6} alt="" />
                                                                        <span>USD Coin (USDC)</span>
                                                                    </a>
                                                                </td>
                                                                <td class="boild align-middle">$56,623.54</td>
                                                                <td class="down align-middle">-2.22%</td>
                                                                <td class='align-middle'><div id="total-revenue-chart-6"></div></td>
                                                                <td class='align-middle'><a href="#" class="btn">Trade</a></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src={chart1} alt="" class="sec-shape1" />
                        <img src={chart2} alt="" class="sec-shape2" />
                    </section>


                    <div class="work-sectigon-area4 sp">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-8 m-auto text-center">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">Buy and Sell BITCOIN</span>
                                        <h2 class="text-anime-style-3">The Simple Way Buy & Sell Coin</h2>
                                    </div>
                                </div>
                            </div>
                            <div class="space60"></div>
                            <div class="row align-items-center">
                                <div class="col-lg-5">
                                    <div class="collapse-navtabs" data-aos="fade-up" data-aos-duration="1100">
                                        <div class="d-flex align-items-start">
                                            <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                                <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" type="button" role="tab" aria-controls="v-pills-home" aria-selected="true">
                                                    <div class="button-area">
                                                        <span class="heading">Flexibility</span>
                                                        <span class="button-pera">We’ve worked with over 400 companies the build blockchain solutions for their business.</span>
                                                    </div>
                                                </button>
                                                <button class="nav-link fade" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false">
                                                    <div class="button-area">
                                                        <span class="heading">Transference</span>
                                                        <span class="button-pera">We’ve worked with over 400 companies the build blockchain solutions for their business.</span>
                                                    </div>
                                                </button>
                                                <button class="nav-link fade" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages" type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false">
                                                    <div class="button-area">
                                                        <span class="heading">Secure & Safe</span>
                                                        <span class="button-pera">We’ve worked with over 400 companies the build blockchain solutions for their business.</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-7 align-items-center _relative" data-aos="fade-up" data-aos-duration="800">
                                    <div class="tabs-author-area">
                                        <div class="tab-content" id="v-pills-tabContent">

                                            <div class="tab-pane  show active fade" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                                <div class="sell-betcoin-images">
                                                    <div class="image1">
                                                        <img src={sellOthers} alt="" />
                                                    </div>
                                                    <div class="image2 animate3">
                                                        <img src={sell1} alt="" />
                                                    </div>
                                                    <div class="image3 animate2">
                                                        <img src={sell2} alt="" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                                <div class="sell-betcoin-images">
                                                    <div class="image1">
                                                        <img src={sellOthers} alt="" />
                                                    </div>
                                                    <div class="image2 animate3">
                                                        <img src={sell1} alt="" />
                                                    </div>
                                                    <div class="image3 animate2">
                                                        <img src={sell2} alt="" />
                                                    </div>
                                                </div>

                                            </div>


                                            <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                                                <div class="sell-betcoin-images">
                                                    <div class="image1">
                                                        <img src={sellOthers} alt="" />
                                                    </div>
                                                    <div class="image2 animate3">
                                                        <img src={sell1} alt="" />
                                                    </div>
                                                    <div class="image3 animate2">
                                                        <img src={sell2} alt="" />
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="work4 sp" id="work">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-8 m-auto text-center">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">how it works</span>
                                        <h2 class="text-anime-style-3">Buy Bitcoin In 3 Steps</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="space30"></div>
                            <div class="row work-top">
                                <div class="col-lg-4 col-md-6" data-aos="fade-right" data-aos-duration="1100">
                                    <div class="work-box-area">
                                        <span>1</span>
                                        <div class="space50"></div>
                                        <div class="work-box">
                                            <div class="heading1">
                                                <h5><a href="#">Create PayCoin Account</a></h5>
                                                <div class="space16"></div>
                                                <p>Creating account with PayCoin is quick, easy, secure. Simply click to account.</p>
                                            </div>
                                            <div class="image">
                                                <img src={work1} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6" data-aos="fade-right" data-aos-duration="900">
                                    <div class="work-box-area active">
                                        <span>2</span>
                                        <div class="space50"></div>
                                        <div class="work-box">
                                            <div class="heading1">
                                                <h5><a href="#">Create PayCoin Account</a></h5>
                                                <div class="space16"></div>
                                                <p>Creating account with PayCoin is quick, easy, secure. Simply click to account.</p>
                                            </div>
                                            <div class="image">
                                                <img src={work2} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6" data-aos="fade-right" data-aos-duration="700">
                                    <div class="work-box-area">
                                        <span>3</span>
                                        <div class="space50"></div>
                                        <div class="work-box">
                                            <div class="heading1">
                                                <h5><a href="#">Start PayCoin Investing</a></h5>
                                                <div class="space16"></div>
                                                <p>Creating account with PayCoin is quick, easy, secure. Simply click to account.</p>
                                            </div>
                                            <div class="image">
                                                <img src={work3} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="mobile-area4 sp">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-5">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">mobile version available </span>
                                        <h2 class="text-anime-style-3">Download PayCoin App</h2>
                                        <div class="space16"></div>
                                        <p data-aos="fade-right" data-aos-duration="700">Take your crypto trading experience to the next level with the PayCoin mobile app. Available for download on both iOS and Android devices, our app puts the power crypto trading right in the palm of your hand.</p>
                                        <div class="space30"></div>
                                        <div class="button" data-aos="fade-right" data-aos-duration="900">
                                            <a href="#"><img src={appleBtn} alt="" /></a>
                                            <a href="#"><img src={gooleBtn} alt="" /></a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-7">
                                    <div class="mobile-area images" data-aos="zoom-out" data-aos-duration="900">
                                        <div class="main-image">
                                            <img src={areaImg} alt="" />
                                        </div>
                                        <div class="coin animate1">
                                            <img src={areaBetcoin} alt="" />
                                        </div>
                                        <div class="qr">
                                            <img src={areaQr} alt="" />
                                        </div>
                                        <div class="shape animate3">
                                            <img src={areaArrow} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <img class="shapes-bg" src={areabg} alt="" />

                    </div>


                    <div class="tes4 sp" id="tes">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 m-auto text-center">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">client feedback</span>
                                        <h2 class="text-anime-style-3">Stories Of Success
                                            On Our Platform</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="space60"></div>
                            <div class="row">
                                {/* <div class="col-lg-12">
                                    <div class="tes4-slider-all" data-aos="fade-up" data-aos-duration="800">
                                        <div class="tes4-slider">
                                            <div class="single-slider">
                                                <ul class="stars">
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                </ul>
                                                <p class="pera">"Trading on PayCoin has been a game-changer for me. The platform's intuitive interface and robust features make it easy for me to manage my crypto portfolio and execute to trades with confidence. What sets PayCoin the apart is its commitment to security – I never have best of PayCoin.”</p>

                                                <div class="bottom-area">
                                                    <div class="image">
                                                        <img src="assets/img/testimonial/testimonial4-smoll-img.png" alt="" />
                                                    </div>
                                                    <div class="heading">
                                                        <h5><a href="#">Jason Behrendorff</a></h5>
                                                        <p>Happy Client</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="single-slider">
                                                <ul class="stars">
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                    <li><i class="fa-solid fa-star"></i></li>
                                                </ul>
                                                <p class="pera">"Trading on PayCoin has been a game-changer for me. The platform's intuitive interface and robust features make it easy for me to manage my crypto portfolio and execute to trades with confidence. What sets PayCoin the apart is its commitment to security – I never have best of PayCoin.”</p>

                                                <div class="bottom-area">
                                                    <div class="image">
                                                        <img src={testimonialSmall} alt="" />
                                                    </div>
                                                    <div class="heading">
                                                        <h5><a href="#">Jason Behrendorff</a></h5>
                                                        <p>Happy Client</p>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="tes4-main-image">
                                            <img src={testimonialMain} alt="" />
                                        </div>
                                        <div class="qute">
                                            <img src={qute} alt="" />
                                        </div>
                                        <div class="buttons">
                                            <button class="arrow-right4">
                                                <i class="fa-solid fa-angle-left"></i>
                                            </button>
                                            <button class="arrow-left4">
                                                <i class="fa-solid fa-angle-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-lg-12">
                                    <div className="tes4-slider-all" data-aos="fade-up" data-aos-duration="800">
                                        <div class="tes4-slider">
                                            <Swiper
                                                spaceBetween={30}
                                                slidesPerView={1}
                                                navigation={{
                                                    nextEl: '.arrow-right4',
                                                    prevEl: '.arrow-left4',
                                                }}
                                                loop={true}
                                                autoplay={{ delay: 3000 }}
                                                pagination={{ clickable: true }}
                                            >
                                                <SwiperSlide>
                                                    <div className="single-slider">
                                                        <ul className="stars">
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                        </ul>
                                                        <p class="pera">"Trading on PayCoin has been a game-changer for me. The platform's intuitive interface and robust features make it easy for me to manage my crypto portfolio and execute to trades with confidence. What sets PayCoin the apart is its commitment to security – I never have best of PayCoin.”</p>
                                                        <div className="bottom-area">
                                                            <div className="image">
                                                                <img src={testimonialSmall} alt="Testimonial" />
                                                            </div>
                                                            <div className="heading">
                                                                <h5><a href="#">Jason Behrendorff</a></h5>
                                                                <p>Happy Client</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>

                                                <SwiperSlide>
                                                    <div className="single-slider">
                                                        <ul className="stars">
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                            <li><i className="fa-solid fa-star"></i></li>
                                                        </ul>
                                                        <p class="pera">"Trading on PayCoin has been a game-changer for me. The platform's intuitive interface and robust features make it easy for me to manage my crypto portfolio and execute to trades with confidence. What sets PayCoin the apart is its commitment to security – I never have best of PayCoin.”</p>
                                                        <div className="bottom-area">
                                                            <div className="image">
                                                                <img src={testimonialSmall} alt="Testimonial" />
                                                            </div>
                                                            <div className="heading">
                                                                <h5><a href="#">Jason Behrendorff</a></h5>
                                                                <p>Happy Client</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            </Swiper>
                                        </div>
                                        <div className="tes4-main-image">
                                            <img src={testimonialMain} alt="Main Testimonial" />
                                        </div>
                                        <div className="qute">
                                            <img src={qute} alt="Quote" />
                                        </div>
                                        <div className="buttons">
                                            <button className="arrow-right4">
                                                <i className="fa-solid fa-angle-left"></i>
                                            </button>
                                            <button className="arrow-left4">
                                                <i className="fa-solid fa-angle-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <img src={test1} alt="" class="sec-shape1" />
                        <img src={test2} alt="" class="sec-shape2" />
                    </div>


                    <div class="blog4 sp" id="blog">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 m-auto text-center">
                                    <div class="heading4">
                                        <span class="span" data-aos="zoom-in-left" data-aos-duration="700">Our Blog</span>
                                        <h2 class="text-anime-style-3">Latest Blog & News</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="space30"></div>
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <div class="" data-aos="zoom-in-up" data-aos-duration="1200">
                                        <div class="blog-box">
                                            <div class="image img100 image-anime">
                                                <img src={blogImg1} alt="" />
                                            </div>
                                            <div class="tags">
                                                <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                                <a href="#"><img src={date} alt="" /> 7/31/2023</a>
                                            </div>
                                            <div class="heading1">
                                                <h5><a href="/blogDetail">The Power of Diversification in Cryptocurrency on Investment</a></h5>
                                                <div class="space16"></div>
                                                <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                                <div class="space16"></div>
                                                <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6">
                                    <div class="" data-aos="zoom-in-up" data-aos-duration="1000">
                                        <div class="blog-box active">
                                            <div class="image img100 image-anime">
                                                <img src={blogImg2} alt="" />
                                            </div>
                                            <div class="tags">
                                                <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                                <a href="#"><img src={date} alt="" /> 7/31/2023</a>
                                            </div>
                                            <div class="heading1">
                                                <h5><a href="/blogDetail">The Best Ultimate Crypto Trading Handbook: Strategies, Tips More</a></h5>
                                                <div class="space16"></div>
                                                <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                                <div class="space16"></div>
                                                <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6">
                                    <div class="" data-aos="zoom-in-up" data-aos-duration="800">
                                        <div class="blog-box">
                                            <div class="image img100 image-anime">
                                                <img src={blogImg3} alt="" />
                                            </div>
                                            <div class="tags">
                                                <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                                <a href="#"><img src={date} alt="" /> 7/31/2023</a>
                                            </div>
                                            <div class="heading1">
                                                <h5><a href="/blogDetail">The Benefits of Diversification in Cryptocurrency Investment</a></h5>
                                                <div class="space16"></div>
                                                <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                                <div class="space16"></div>
                                                <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>

                <div class="cta4">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6 m-auto text-center">
                                <div class="heading1-w">
                                    <h2>Join Our Investment Area</h2>
                                    <div class="space16"></div>
                                    <p>Take your crypto trading experience to the next level with the PayCoin mobile app. Available for download on both iOS and Android devices, our app puts the power crypto trading right in the palm of your hand.</p>

                                    <div class="space30"></div>
                                    <div class="buttons">
                                        <a class="theme-btn5" href="/contact">Sign Up Now <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                        <a class="theme-btn6" href="/contact">Explore PayCoin Market <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <img src={test1} alt="" class="sec-shape1" />
                    <img src={test2} alt="" class="sec-shape2" />
                </div>

                <div class="footer4 _relative">
                    <div class="container">
                        <div class="footer-bg">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-12">
                                    <div class="footer-logo-area">
                                        <a href="/" class="logo">
                                            <img src={footerlogo} alt="" />
                                        </a>
                                        <div class="space20"></div>
                                        <h5>Join Our Blockchain PayCoin Community</h5>
                                        <div class="space30"></div>
                                        <a class="theme-btn5" href="/contact">Sign Up Now <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                    </div>
                                </div>

                                <div class="col-lg col-md-4 col-12">
                                    <div class="single-footer-items">
                                        <h3>Explore</h3>

                                        <ul class="menu-list">
                                            <li><a href="#">Tokens Sale</a></li>
                                            <li><a href="#">Ecosystem</a></li>
                                            <li><a href="#">Wallets Sale </a></li>
                                            <li><a href="#">Gravity Dex</a></li>
                                            <li><a href="#">Whitepaper</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-lg col-md-4 col-12">
                                    <div class="single-footer-items">
                                        <h3>Solution</h3>

                                        <ul class="menu-list">
                                            <li><a href="#">Token Suite</a></li>
                                            <li><a href="#">Work Process</a></li>
                                            <li><a href="#">Wallets Sale </a></li>
                                            <li><a href="#">Tokenisation</a></li>
                                            <li><a href="#">Portal Token</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="col-lg col-md-4 col-12">
                                    <div class="single-footer-items pl-5">
                                        <h3>Quick Links</h3>

                                        <ul class="menu-list">
                                            <li><a href="#">Our Features </a></li>
                                            <li><a href="#">Why Blockchain</a></li>
                                            <li><a href="/blog">Our Blog</a></li>
                                            <li><a href="/">Introduction</a></li>
                                            <li><a href="/contact">Contact Us</a></li>
                                        </ul>
                                    </div>
                                </div>


                                <div class="col-lg-2 col-md-4 col-12">
                                    <div class="single-footer-items">
                                        <h3>Need Help?</h3>

                                        <ul class="contact-info">
                                            <li><a href="tel:+(1)1234567890">+(1) 123 456 7890</a></li>
                                            <li><a href="mailto:paycoindemo@.com">paycoindemo@.com</a></li>
                                            <li><a href="#">paycoinwebsite.com</a></li>
                                        </ul>

                                        <ul class="icons">
                                            <li><a href="#"><i class="fa-brands fa-facebook-f"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-google-plus-g"></i></a></li>
                                            <li><a href="#"><i class="fa-brands fa-linkedin-in"></i></a></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <img class="footer-shape1" src={footerimg3} alt="" />
                            <img class="footer-shape2" src={footerimg1} alt="" />
                            <img class="footer-shape3" src={footerimg2} alt="" />
                            <img class="footer-shape4" src={footerimg3} alt="" />
                        </div>

                        <div class="space70"></div>
                    </div>

                    <div class="copyright-area _relative">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 text-center">
                                    <div class="coppyright">
                                        <p>Copyright © 2024 PayCoin crypto theme. All rights reserved.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

export default SingleIndexHomepages